/**
 * Created by mukund on 8/24/17.
 */

angular.module('mediacloudApp')
    .directive('dropbox', ['CollectionService', 'Tenant', 'UploadErrors', 'BaseFileService', 'BatchService', 'Principal', function(CollectionService, Tenant, UploadErrors, BaseFileService, BatchService, Principal){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/dropbox/dropbox.html',
            scope: {
                cid: '@',
                errors: '='
            },
            link: function(scope, element, attrs) {

                var userInfo = Principal.getUserInfo();
                scope.userName = userInfo.userName;
                scope.userFullName = userInfo.userFullName;

                var resetUploader = function(){
                    if(scope.errors) {
                        scope.errors.length = 0;
                    }
                    scope.batch = {};
                    scope.file = {readyForUpload: false, uploadStarted: false};
                };

                Tenant.info().then(function (data) {

                    if(data) {
                        scope.tenantId = data.id;
                        scope.uploadUrl = data.uploadUrl;
                        scope.contributor = data.showUserFullName ? scope.userFullName : scope.userName;
                    }

                });

                // Upload the batch when the user clicks on the upload batch button
                scope.uploadBatch = function(event){
                    var dropbox = new CollectionService.GetStudentDropBoxCollection({cid: scope.cid});
                    dropbox.$save(function(response) {
                        scope.destination = {title: "DropBox", cid: response.cid, childCollections: []};
                        scope.file.metadata.destination = scope.destination;
                        var uploadParams = [{userId: scope.userName}, {tenantId: scope.tenantId}];
                        if(scope.file.needsTranscoding) {
                            uploadParams.push({generateThumbnail: true});
                        } else {
                            uploadParams.push({skipProcessing: true});
                        }
                        var addBatchRequest = new BatchService.CreateBatch();
                        addBatchRequest.$save(function(batch){
                            angular.merge(scope.batch, batch);
                            BaseFileService.GetUploadToken.get(function(data){
                                uploadParams.push({jwt: data.token});
                                var fileItem = scope.batch.uploader.queue[0];
                                fileItem.formData = uploadParams;
                                fileItem.url = scope.uploadUrl;
                                fileItem.upload();
                                scope.file.uploadStarted = true;
                            }, function(error){
                                scope.errors.push({id: 'de' + Date.now(), msg: UploadErrors.GET_UPLOAD_TOKEN.formatMessage({name: scope.file.name})});
                                // Cancel & Remove the file from the file list since this is a fatal error
                                scope.cancelFile();
                            });
                        }, function(){
                            scope.errors.push({id: 'de' + Date.now(), msg: UploadErrors.CREATE_BATCH});
                        });
                    });
                    event.stopPropagation();
                };

                // Cancel Operations
                scope.cancelFile = function(event) {
                    var fileId = scope.file.fileId ? scope.file.fileId : scope.file.mediacloudFileId,
                        jobId = scope.file.jobId;
                    if(fileId && !jobId){
                        // Cancel the basefile entry first, if it already exists before updating the UI
                        BaseFileService.CancelBaseFile.erase({id: fileId}, function(){
                            scope.closeUploader();
                        }, function(){
                            scope.errors.push({id: 'de' + Date.now(), msg: UploadErrors.CANCEL_FILE});
                        });
                    } else {
                        scope.closeUploader();
                    }
                    event.stopPropagation();
                };

                scope.updateFileMetadata = function(){
                    var fileId = scope.file.fileId ? scope.file.fileId : scope.file.mediacloudFileId;
                    if(fileId){
                        var baseFileResource = new BaseFileService.AddMetadata({
                            id: fileId,
                            title: scope.file.metadata.title,
                            contributor: scope.file.metadata.contributor,
                            description: scope.file.metadata.description.trim(),
                            isStudentUpload: true
                        });
                        baseFileResource.$save(function(){
                            var notify = scope.file.sendNotificationToUser ? scope.file.sendNotificationToUser : false;
                            var baseFileNotificationResource = new BaseFileService.NotifyUser({id: fileId, notify: notify});
                            baseFileNotificationResource.$save(function(){
                            }, function(){
                                scope.errors.push({id: 'de' + Date.now(), code: UploadErrors.SEND_USER_NOTIFICATION});
                            });
                        }, function(){
                            scope.errors.push({id: 'de' + Date.now(), msg: UploadErrors.UPDATE_FILE_METADATA});
                        });
                    }
                };

                scope.closeUploader = function(){
                    $('#dbModal').modal('hide');
                    if(scope.batch.uploader) {
                        scope.batch.uploader.cancelAll();
                        scope.batch.uploader.clearQueue();
                    }
                    resetUploader();
                };

                resetUploader();

                scope.$watch('file.readyForUpload', function() {
                    if(scope.file && scope.file.readyForUpload){
                        $('#dbModal').modal('show');
                    }
                });

                // These events will handle scenarios where the user clicks outside the modal to close it
                $('#dbModal').on('shown.bs.modal', function () {
                    $('.modal-dialog').on('click', function(e) {
                        e.stopPropagation();
                    });
                    $('body').on('click', function(e) {
                        scope.closeUploader();
                        e.stopPropagation();
                    });
                    modalFocus('#filemeta-title', '#cancelDropboxUploadBtn');
                }).on('hidden.bs.modal', function () {
                    $('.modal-dialog').off('click');
                    $('body').off('click');
                });

                var modalFocus = function(first, last){
                    var firstItem = $(first),
                        lastItem = $(last);

                    /*set focus on first item*/
                    firstItem.focus();

                    /*redirect last tab to first input*/
                    lastItem.on('keydown', function (e) {
                        if ((e.which === 9 && !e.shiftKey)) {
                            e.preventDefault();
                            firstItem.focus();
                        }
                    });

                    /*redirect first shift+tab to last input*/
                    firstItem.on('keydown', function (e) {
                        if ((e.which === 9 && e.shiftKey)) {
                            e.preventDefault();
                            lastItem.focus();
                        }
                    });
                };
            }
        }

    }]);
